import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import FormDialog from "../FormDialog";
import { ModeratorForm } from "../moderator/ModeratorForm";
import ModeratorSearch from "../moderator/ModeratorSearch";
import LinkDialog from "../LinkDialog";
import { AssessmentCentreModeratorModerationEndDateForm } from "../assessmentcentre/AssessmentCentreModeratorModerationEndDateForm";
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: false, label: 'First Name' },
    { id: 'Surname', numeric: false, disablePadding: false, label: 'Surname' },
    { id: 'IDNo', numeric: false, disablePadding: false, label: 'ID Number' },
    { id: 'RegistrationNumber', numeric: false, disablePadding: false, label: 'Registration Number' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: false, label: 'Registration End Date' },
    { id: 'ModerationEndDate', numeric: false, disablePadding: true, label: 'Moderation End Date' }
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();
const updateFormRef = React.createRef();

class AssessmentCentreModeratorSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            linkDialogOpen: false,
            formDialogOpen: false,
            selectedModerator: null,
            selectedPerson: null,
            updateDialogOpen: false,
            propmtOpen: false,
            promptTitle: "Remove Moderator from Assessment Centre",
            promptContent: "Are you sure you want to remove this moderator from the Assessment Centre?",
            removeMessage: "",
            removeMessageStyle: "",
            searchParameters: [{ Name: "assessmentcentreID", Value: this.props.location.state.selection }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "link", label: '', icon: 'LinkIcon', tooltip: "Link existing moderator to Assessment Centre", visible: this.props.menuPermissionItem.Add },
                        {
                            id: 'view', label: '', icon: 'ViewIcon', tooltip: 'View Selected Moderator Details',
                            disabled: utils.isNull(this.state.selectedModerator)
                        },
                        {
                            id: 'remove', label: '', icon: 'DeleteIcon', tooltip: 'Remove Moderator from Assessment Centre',
                            disabled: utils.isNull(this.state.selectedModerator), visible: this.props.menuPermissionItem.Delete
                        },
                        {
                            id: 'updateDate', label: 'Update Moderator Moderation End Date', tooltip: 'Update Moderator Moderation End Date',
                            disabled: utils.isNull(this.state.selectedModerator), visible: this.props.menuPermissionItem.Edit
                        }
                    ]
                }
            ]
        };

    }
    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/assessmentcentre',
                state: { selection: this.props.location.state.selection }
            });
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("view" === buttonId) {
            this.setState({ removeMessage: "" }, this.viewLearner());
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, removeMessage: "" })

        }
        else if ("updateDate" === buttonId) {
            this.setState({ updateDateDialogOpen: true, message: "" })

        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                updateDateDialogOpen: false
            })
        }
    }

    dialogUpdateActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                updateDateDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedModerator: selection[0].Id, removeMessage: "", selectedPerson: selection[0].ModeratorID });
        }
        else {
            this.setState({ selectedModerator: null, removeMessage: "", selectedPerson: null });
        }
        toolbarRef.current.setButtonDisabled("remove", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("view", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("updateDate", selection === null || selection.length === 0);
    }

    successfulRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedModerator: null, removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    removeModerator(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedModerator}&assessmentcentreId=${this.props.location.state.selection}`;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }

    viewLearner = () => {
        this.setState({ formDialogOpen: true })
    }


    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">

                <p className="breadcrumbs">
                    {"Assessment Centre > Moderators " + (this.props.location.state.providerName !== null ? "> " + this.props.location.state.providerName + (this.props.location.state.providerSDLNumber !== null ? " - " + this.props.location.state.providerSDLNumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.removeMessage} alertStyle={this.state.removeMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    <EnhancedTable
                        headCells={headCells}
                        dataUrl={`api/sims/assessmentcentremoderator/GetAssessmentCentreModerators`}
                        height="60vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <FormDialog
                    open={this.state.formDialogOpen}
                    dialogTitle={"View Assessment Centre Moderator Details"}
                    viewRef={this}
                    formRef={addFormRef}
                    isView={this.props.menuPermissionItem.Edit == 1 ? false : true}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <ModeratorForm
                        ref={addFormRef}
                        id={this.state.selectedPerson}
                        disableFields={false}
                    />
                </FormDialog>

                <FormDialog
                    open={this.state.updateDateDialogOpen}
                    dialogTitle={"Update Moderator Moderation End Date"}
                    viewRef={this}
                    entityId={this.state.selectedModerator}
                    formRef={updateFormRef}
                    usePut={true}
                    saveUrl={"api/sims/assessmentcentremoderator/UpdateModeratorModerationEndDate"}
                    closeHandler={(isCancelled, linked) => this.dialogUpdateActionHandler(isCancelled, linked)}
                >
                    <AssessmentCentreModeratorModerationEndDateForm ref={updateFormRef} id={this.state.selectedModerator} dataURL='api/sims/assessmentcentremoderator/GetFindModeratorModerationEndDate' controllerName='assessmentcentremoderator' />
                </FormDialog>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={`Link Moderators to Assessment Centre > ${this.props.location.state.providerName} - ${this.props.location.state.providerSDLNumber
                        }`}
                    linkName={"moderators"} postUrl={"api/sims/assessmentcentremoderator/LinkAssessmentCentreModerator"} usePost={true}
                    selectionId={this.props.location.state.selection}
                >
                    <ModeratorSearch
                        dataUrl={"api/sims/assessmentcentremoderator/GetSearchLinkableModerators"}
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.selection} programmeType="Q"
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.removeModerator("api/sims/assessmentcentremoderator/RemoveAssessmentCentreModerator") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(connect()(withMenuPermission(AssessmentCentreModeratorSearch)));
